module.exports = __webpack_public_path__ + "static/media/Suli-Compound.a0661179.webp";